/**
 * Quant data seam. Hooks, pages and components import ONLY from here; nothing
 * outside `src/app/lib/quant` touches the real client or the mock generators.
 *
 * Eleven operations are real (spec 073 added the instrument sources read) (the preview is a REST session since spec 039): config, strategies, runs list, run, start, cancel,
 * log, delete, chart, data coverage and (spec 040) the market feed status go through `quantRealApi` to echo-core's `/quant` routes
 * (spec 037; shapes and error semantics are documented in `types.ts` and
 * `quantRealApi.ts`). Spec 070: the Manual market stream and the strategy view are the real
 * `WS /api/quant/view` sessions (`viewSession.ts`), the symbol list is built from the feed's
 * `live_instruments` (`liveSymbols.ts`), and only the indicator catalog stays a client-side fixture
 * (echo-quant publishes none; `opened.catalog_version` is checked against it).
 * Spec 041: the eight live-session operations are real (`/quant/live`); the mock Live deployments are gone.
 */
import { createMarketViewSession, createStrategyViewSession } from './viewSession'
import { createRestPreviewSession } from './previewRestSession'
import { INDICATOR_CATALOG } from './fixtures/indicators.fixture'
import type { QuantApi } from './types'
import { quantRealApi } from './quantRealApi'

// Seam re-exports so pages/components/hooks never import fixtures or engines directly.
export { DEFAULT_INDICATORS, type ManualIndicator } from './fixtures/indicators.fixture'

export const quantApi: QuantApi = {
  getConfig: quantRealApi.getConfig,
  listStrategies: quantRealApi.listStrategies,
  listRuns: quantRealApi.listRuns,
  getRun: quantRealApi.getRun,
  startRun: quantRealApi.startRun,
  cancelRun: quantRealApi.cancelRun,
  getRunLog: quantRealApi.getRunLog,
  deleteRun: quantRealApi.deleteRun,
  getRunChart: quantRealApi.getRunChart,
  getData: quantRealApi.getData,
  getInstrumentSources: quantRealApi.getInstrumentSources,
  getFeed: quantRealApi.getFeed,
  listLiveSessions: quantRealApi.listLiveSessions,
  getLiveSession: quantRealApi.getLiveSession,
  startLiveSession: quantRealApi.startLiveSession,
  stopLiveSession: quantRealApi.stopLiveSession,
  getLiveEvents: quantRealApi.getLiveEvents,
  getLiveLog: quantRealApi.getLiveLog,
  getLiveEquity: quantRealApi.getLiveEquity,
  deleteLiveSession: quantRealApi.deleteLiveSession,
  listSavedConfigs: quantRealApi.listSavedConfigs,
  saveConfig: quantRealApi.saveConfig,
  deleteConfig: quantRealApi.deleteConfig,
  openPreview: (args) => createRestPreviewSession(args, { post: quantRealApi.postPreview }),
  listIndicatorCatalog: () => Promise.resolve(INDICATOR_CATALOG.map((t) => ({ ...t }))),
  openMarketStream: (args) => createMarketViewSession(args),
  openStrategyView: (args) => createStrategyViewSession(args),
}
